<template
  rel="stylesheet"
  href="https://cdn.bootcss.com/bootstrap/3.3.5/css/bootstrap.css"
>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("users.list") }}</h5>

    <div class="columns mt-3">
      <div class="column is-one-third">
        <div class="control has-icons-left">
          <input
            class="input is-normal"
            type="text"
            placeholder="Search"
            v-model="searchQuery"
            @input="currentPage = 1"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-search"></i>
          </span>
        </div>
      </div>
    </div>

    <vue-element-loading :active="isLoading" spinner="spinner" />
    <table class="table is-fullwidth">
      <thead>
        <tr class="has-text-centered">
          <th width="30%">{{ $t("Email") }}</th>
          <th>{{ $t("Name") }}</th>
          <th>{{ $t("profile.userRole") }}</th>
          <th>{{ $t("Created_at") }}</th>
          <th>{{ $t("users.lastLogin") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, userId) in filteredLists"
          :key="userId"
          class="has-text-centered"
        >
          <td class="has-text-left">
            <router-link
              :to="{ name: 'usersView', query: { userId: item.userId } }"
            >
              {{ item.userId }}
            </router-link>
          </td>
          <td>{{ item.userName }}</td>
          <td>
            <span v-if="item.userRole == 'admin'">
              {{ $t("profile.admin") }}
            </span>
            <span v-else>
              {{ $t("profile.user") }}
            </span>
          </td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.lastLogin }}</td>
        </tr>
      </tbody>
    </table>

    <nav
      v-if="isPager == true"
      class="pagination is-centered is-small"
      role="navigation"
      aria-label="pagination"
    >
      <paginate
        v-model="currentPage"
        :page-count="getPageCount"
        :click-handler="clickCallback"
        :page-range="3"
        :margin-pages="2"
        :prev-text="'<'"
        :next-text="'>'"
        :page-class="'page-item'"
        :container-class="'pagination-list'"
        :page-link-class="'pagination-link'"
      >
      </paginate>
    </nav>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb";
import { ImsrUsers } from "@/lib/imsrUsers.js";
import { computed, ref } from "@vue/reactivity";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import VueElementLoading from "vue-element-loading";

import Paginate from "vuejs-paginate-next";

export default {
  components: {
    Breadcrumb,
    paginate: Paginate,
    VueElementLoading,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const usersList = ref([]);
    const searchQuery = ref("");
    const currentPage = ref(1); // 現在のページ
    const perPage = ref(50); // 1ページあたりのアイテム数
    const breadcrumb = ref([
      { title: "Admin", path: "#", isActive: true },
      { title: "Users List", path: "#", isActive: true },
    ]);
    const isLoading = ref(false);

    const getTenantUsers = async () => {
      isLoading.value = true;
      try {
        const imsrUsers = new ImsrUsers();
        usersList.value = await imsrUsers.getTenantUsers(
          store.getters.tenantId
        );
        isLoading.value = false;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getTenantUsers();

    const isPager = computed(() => {
      return filteredUsers.value.length > perPage.value;
    });

    // 検索クエリに基づいてユーザーリストをフィルタリング
    const filteredUsers = computed(() => {
      return usersList.value.filter(
        (user) =>
          user.userId.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
          user.userName.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    // ページネーションに基づいてリストを取得
    const filteredLists = computed(() => {
      let end = currentPage.value * perPage.value;
      let start = end - perPage.value;
      return filteredUsers.value.slice(start, end);
    });

    const getLists = computed(() => {
      //  1ページに表示されるアイテムのみ抽出
      let current = currentPage.value * perPage.value;
      let start = current - perPage.value;
      return usersList.value.slice(start, current);
    });

    const getPageCount = computed(() => {
      return Math.ceil(filteredUsers.value.length / perPage.value);
    });

    const clickCallback = (pageNum) => {
      currentPage.value = Number(pageNum); //ページネーションで選択したページ数
    };

    return {
      projectId: computed(() => route.params.projectId),
      breadcrumb,
      getLists,
      getPageCount,
      currentPage,
      clickCallback,
      usersList,
      isPager,
      searchQuery,
      filteredLists,
      isLoading,
    };
  },
};
</script>
<style></style>
